<button
	mat-button
	color="accent"
	[title]="language[languageSelection[currentLanguage]]"
	(click)="changeLang(languageSelection[currentLanguage])"
	aria-label="Change language"
>
	{{ languageSelection[currentLanguage] }}
</button>
